import React from "react";
import "../../Styles/certified/celcom.css";

export default function Finzly() {
  return (
    <>
      <div className="celcom-certified-details-section">
        <div className="celcom-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="celcom-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="celcom-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="celcom-certified-badge"
            />
            <div className="celcom-certified-company-names">
              <a href="https://www.celcomsolutions.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/celcom/celcom.png"
                alt="Walkzero Logo"
                className="celcom-certified-company-logo"
              />
            </a>
              <h1 className="celcom-certified-full-name">
               Celcom Solutions Global Private Limited 
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="celcom-certified-details-right">
            <img
              src="/assets/celcom/celcom_2.jpg"
              alt="Finzly Office"
              className="celcom-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="celcom-certified-description">
          <h2>
            Why Celcom Solutions Global Private Limited  is an Outstanding Workplaces
          </h2>
          <p>
            Celcom- Being a market leader in Telecom domain and with a strong focus the BFSI industry, we support Greenfield Implementation Transformation and Managed Services. Celcom has extensive hands-on experience in delivering quality services for global clients. We are an ISO/IEC 27001:2022 certified company that helps organizations with Implementation, Solutions, and Consulting Services for the Oracle BSS/OSS product stack and digital transformation, testing, and data services.


          </p>
          <p>
            Founded in 2010 in the UK and having regional offices in India (Chennai), we bring years of domain expertise and global experiences to play. Our focus has been on offering the right portfolio of Products and Services to our clients across different verticals.
          </p>
          <p>
           At Celcom, we have our global footprint across multiple geographies, including APAC, MENA, the Middle East, and the UK. We have been able to deliver our clients industry-specific solutions in digital transformation, testing, data services, domain-led OSS/BSS stack services, and consulting.

          </p>
          
        </div>
        
        <div className="celcom-certified-info-cards">
          <div className="celcom-certified-info-card">
            <div className="celcom-certified-info-title">COMPANY SIZE</div>
            <div className="icom-certified-info-value">450 Employees</div>
          </div>
          <div className="celcom-certified-info-card">
            <div className="celcom-certified-info-title">INDUSTRY</div>
            <div className="celcom-certified-info-value">IT / Telcom- BFSI 

</div>
          </div>
          <div className="celcom-certified-info-card">
            <div className="celcom-certified-info-title">CONNECT</div>
            <div className="celcom-certified-info-icons">
              <span className="celcom-certified-icon-round">
                <a href="https://www.celcomsolutions.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="celcom-certified-icon-round">
                <a href="https://www.linkedin.com/company/celcomsolutions/?originalSubdomain=in" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="celcom-certified-icon-round">
                <a href="https://www.facebook.com/CelcomSolutionsLtd/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="celcom-certified-info-card">
            <div className="celcom-certified-info-title">LOCATION (HQ)</div>
            <div className="celcom-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="celcom-certified-recognition-section">
          <h2 className="celcom-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="celcom-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="celcom-certified-recognition-image"
            />
          </div>
          <div className="celcom-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="celcom-certified-life-section">
          <h2 className="celcom-certified-life-title">
            Life at Celcom Solutions Global Private Limited 
          </h2>
          <div className="celcom-certified-life-gallery">
            <div className="celcom-certified-life-col">
              <img src="/assets/celcom/celcom_1.jpg" alt="Office 1" className="celcom-certified-life-img" />
              <img src="/assets/celcom/celcom_2.jpg" alt="Team 1" className="celcom-certified-life-img" />
            </div>
            <div className="celcom-certified-life-col celcom-certified-life-center">
              <img src="/assets/celcom/celcom_5.jpg" alt="Main Office" className="celcom-certified-life-img celcom-certified-life-img-large" />
            </div>
            <div className="celcom-certified-life-col">
              <img src="/assets/celcom/celcom_3.jpg" alt="Office 2" className="celcom-certified-life-img" />
              <img src="/assets/celcom/celcom_4.jpg" alt="Team 2" className="celcom-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
